import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';

import { Typography } from '@mui/material';

import ValidityAdornment from './ValidityAdornment';

const NotifyContentLabel = () => {
  const [{ contentValidity }] = useMassActionState();
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex' }}>
      <Typography
        color={contentValidity.contentIsEmpty ? 'error' : 'textSecondary'}
        style={{
          margin: '5px 10px',
        }}
        variant="subtitle2"
        noWrap
      >
        {t('smartmessaging.contentEditor.notify.content')}
      </Typography>
      <ValidityAdornment
        valid={!contentValidity.contentIsEmpty}
        message={t('smartmessaging.contentEditor.notify.contentIsEmpty')}
      />
    </div>
  );
};

export default NotifyContentLabel;
